module.exports = __webpack_public_path__ + "static/media/Soybean12R5.213b1d0d.PNG";